import { AuthService } from './serv/auth.service';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from './serv/user.service';



@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [
    // animation triggers go here
  ]
})
export class AppComponent {
  constructor(private userService: UserService, private auth: AuthService, router: Router) {
    this.auth.user$.subscribe(user => {
    if (!user) return;
      userService.save(user);

      let returnUrl = localStorage.getItem('returnUrl');
      if (!returnUrl) return;
      localStorage.removeItem('returnUrl');
      router.navigateByUrl(returnUrl);
   })
  };
}
